import { MonthName, ReportingMonth } from '../../../commonTypes/ChargeTypes'

export function getReportingMonth(fromDate?:Date):ReportingMonth{
	const d = fromDate || new Date()
	const month = d.toLocaleString('default', { month: 'long' }) as MonthName
	return `${month}-${d.getFullYear()}`
}

export const getReportingYear = (reportingMonth: ReportingMonth) => parseFloat(reportingMonth.split('-')[1])
